import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '荷物の注意事項',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
};
